<template>
  <!-- Approved in this case means the user has been approved as a consumer but not yet as a creator -->
  <CreatorApply v-if="orgData.waitlist_status === waitlistStatus.approved" />
  <CreatorPending v-if="orgData.waitlist_status === waitlistStatus.creatorPending" />
  <CreatorRejected v-if="orgData.waitlist_status === waitlistStatus.creatorRejected" />
</template>

<script>
import CreatorApply from "@/components/onboarding/CreatorApply.vue";
import CreatorPending from "@/components/onboarding/CreatorPending.vue";
import { waitlistStatus } from "@/enums/waitlist-enum";
import CreatorRejected from "@/components/onboarding/CreatorRejected.vue";
import { mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "Onboarding",
  components: { CreatorRejected, CreatorPending, CreatorApply },
  data() {
    return {
      waitlistStatus,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["orgData"]),
  },
};
</script>
